export default __webpack_public_path__ + "static/media/7d004a919b19230f2d85168ca455f8cf.jpg";